module.exports = __webpack_public_path__ + "static/media/outline-icons.ad97afd3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/fonts/outline-icons.ttf
// module id = 4410
// module chunks = 0